import * as React from "react";
import classnames from "classnames";
import { Hr } from "@grandvisionhq/elements";
/* empty css                             */
import { useProductDetailSlots } from "../../../../../../slots/slots/context.js";
import { ProductTag } from "../../../../components/ProductTag/modules/EcommContent/components/ProductTag/ProductTag.js";
import { PriceSectionContainer } from "../../../../components/PriceSection/modules/EcommContent/components/PriceSection/PriceSectionContainer.js";
import { VariantSelectorTree } from "../../../../components/VariantSelectorTree/modules/EcommContent/components/VariantSelectorTree/VariantSelectorTree.js";
import { AccessoriesQuantitySelector } from "../../../components/AccessoriesQuantitySelector/modules/EcommContent/AccessoriesEcommContent/components/AccessoriesQuantitySelector/AccessoriesQuantitySelector.js";
import { AccessoriesCTA } from "../../../components/AccessoriesCTA/modules/EcommContent/AccessoriesEcommContent/components/AccessoriesCTA/AccessoriesCTA.js";
import { useProductData } from "../../../../../../context/context/product-context-hooks.js";
const AccessoriesEcommContent = ({ className, ctaRef }) => {
  const {
    activeVariant: { displayName, sku: activeSku, isExcludedFromCheckout }
  } = useProductData();
  const { Slots } = useProductDetailSlots();
  return /* @__PURE__ */ React.createElement(
    "section",
    {
      "aria-label": displayName,
      className: classnames("accessories-ecomm-content", className)
    },
    /* @__PURE__ */ React.createElement(ProductTag, { className: "accessories-ecomm-content__tag" }),
    /* @__PURE__ */ React.createElement(PriceSectionContainer, null),
    /* @__PURE__ */ React.createElement(Hr, null),
    /* @__PURE__ */ React.createElement(VariantSelectorTree, null),
    /* @__PURE__ */ React.createElement(AccessoriesQuantitySelector, null),
    /* @__PURE__ */ React.createElement("div", { className: "accessories-ecomm-content__column" }, Slots.DynamicDeliveryIndicator ? /* @__PURE__ */ React.createElement(
      Slots.DynamicDeliveryIndicator,
      {
        isExcludedFromCheckout,
        deliveryItems: [{ sku: activeSku, quantity: 1 }]
      }
    ) : null, /* @__PURE__ */ React.createElement("div", { ref: ctaRef }, /* @__PURE__ */ React.createElement(AccessoriesCTA, null)), Slots.AfterCTA ? /* @__PURE__ */ React.createElement(Slots.AfterCTA, null) : null)
  );
};
export {
  AccessoriesEcommContent
};
//# sourceMappingURL=AccessoriesEcommContent.js.map
